import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';

/**
 * Replacement for the old paid pricing pages (/plans, /subscription,
 * /subscription-plans, /pricing). Renders a brief "we're free now" banner
 * and auto-redirects to the search page after a short dwell so returning
 * users / crawled links don't dead-end.
 */
export default function FreeMarketplaceRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate('/search', { replace: true }), 2500);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-emerald-50 px-6"
      data-testid="free-marketplace-redirect"
    >
      <div className="max-w-md text-center">
        <div className="w-16 h-16 mx-auto bg-emerald-100 rounded-full flex items-center justify-center mb-6">
          <Check className="h-8 w-8 text-emerald-600" />
        </div>
        <h1 className="text-3xl font-semibold text-slate-900 mb-3" data-testid="redirect-heading">
          OnSiteHand is free to use
        </h1>
        <p className="text-slate-600 mb-6">
          Search and message tradespeople directly.
        </p>
        <button
          onClick={() => navigate('/search', { replace: true })}
          className="inline-flex items-center justify-center rounded-full bg-emerald-600 px-6 py-3 text-white font-medium hover:bg-emerald-700 transition-colors"
          data-testid="redirect-continue-btn"
        >
          Browse tradespeople
        </button>
      </div>
    </div>
  );
}
